import request from './request.js'

export default {
	// ===================================================================穿透云主机
	// 添加穿透云主机
	addFrpSingle(params) {
		//对象传参：ServerAddress 服务器地址、ServerPort 服务器端口 、Token 服务器口令
		return request({
			url: '/frp/AddServer',
			method: 'post',
			data: params
		});
	},
	// 查询所有穿透云主机
	getFrpAll() {
		return request({
			url: '/frp/GetAllServer', // code: 200 success
			method: 'get',
		});
	},
	// 修改穿透云主机
	revampPenetrate(params) {
		return request({
			url:'/frp/SetClientUsefrpServer'+params,
			method:'post'
		})
	},
	// 删除穿透云主机
	delFrpServer(params){
		return request({
			url: '/frp/RemoveServer' + params,
			method: 'post',
		});
	},
	// ===================================================================穿透云主机
	
	// ===================================================================节点信息
	// 获取穿透节点信息
	getPaginatedClient(params){
		var {query,data} = params;
		return request({
			url:'/frp/PaginatedClient' +  query,
			method:"post",
			data: data,
		})
	},
	// 获取节点代理信息
	getAllClientAgent(params) {
		return request({
			url:'/frp/GetAllClientAgent'+params,
			method:'get'
		})
	},
	// 添加穿透节点信息
	addPaginatedClient(params){
		return request({
			url:'/frp/SetClient',
			method:"post",
			data:params
		})
	},
	// 添加/修改节点代理信息
	setClientAgent(params){
		return request({
			url:'/frp/SetClientAgent',
			method:"post",
			data:params
		})
	},
	// 删除穿透节点
	delClient(params){
		return request({
			url:'/frp/RemoveClient' + params,
			method:"post",
		})
	},
	// 删除穿透代理
	delClientAgent(params){
		return request({
			url:'/frp/RemoveClientAgent' + params,
			method:"post",
		})
	},
	
	
	
	
	// ===================================================================节点信息
	
	
	
	
	//单个修改穿透服务器信息
	setFrpSingle(params) {
		//对象传参： 穿透服务器信息DTO（查询的所有信息）
		return request({
			url: '/frp/Set',
			method: 'post',
			data: params //需要对象传参这么写
		});
	},
	
	
	
	
	
	
	
	
}
